import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './locale/en.json'
import tw from './locale/zh-TW.json'

const resources = {
  en: {
    translation: en
  },
  'zh-TW': {
    translation: tw
  }
}

i18n.use(initReactI18next).init({
  resources,
  lng: 'en', // default language
  fallbackLng: 'zh-TW', // fallback language
  interpolation: {
    escapeValue: false
  }
})

export default i18n
